import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import CustomClipLoader from '~components/atoms/CustomClipLoader';

import DiscountDetailsForm from '../DiscountDetailsForm';

import * as Styles from './_productManagementDiscountDetails.module.scss';
import { ModuleEnum, PermissionsEnum } from '~utils/enums';
import ActionButton from '~components/atoms/ActionButton';

const DiscountDetailsModal = () => {
    const dispatch = useAppDispatch();

    const selectedDiscountSettings = useAppSelector(state => state.setting.discounts.selectedDiscount);
    const productSettingDetailsModalIsEditing = useAppSelector(state => state.setting.modals.productManagementDiscountDetailsModalIsEditing);
    const isOpen = useAppSelector(state => state.setting.modals.productManagementDiscountDetailsModalIsOpen);
    const getSettingsError = useAppSelector(state => state.setting.errors.getSettings);
    const getSettingsIsLoading = useAppSelector(state => state.setting.loadings.getSettings);
    const access = useAppSelector(state => state.auth.userDetails.access);

    const hasEditAccess = access.find(item => item.permission === PermissionsEnum.Edit)?.modules.find(module => module === ModuleEnum.Setting);

    const toggleIsEditing = () => dispatch(combinedActions.settingSetProductManagementDiscountDetailsModalIsEditing(!productSettingDetailsModalIsEditing));

    const handleModalOnClose = () => {
        dispatch(combinedActions.settingResetUpdateSettingsState());
        dispatch(combinedActions.settingSetProductManagementDiscountDetailsModalIsOpen(!isOpen));
        dispatch(combinedActions.settingSetProductManagementDiscountDetailsModalIsEditing(false));
    };

    return (
        <Modal
            title='Discount Details'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            {getSettingsIsLoading
                ? (
                    <CustomClipLoader
                        blackBorder
                        className={Styles.loader}
                    />
                )
                : (getSettingsError
                    ? (
                        <Text
                            isError
                            label={getSettingsError}
                        />
                    )
                    : (
                        <div className={Styles.container}>

                            {hasEditAccess
                                            && (
                                                <ActionButton
                                                    label={productSettingDetailsModalIsEditing ? 'Disable editing' : 'Enable editing'}
                                                    onClick={toggleIsEditing}
                                                    className={Styles['edit-button']}
                                                />
                                            )
                            }

                            <DiscountDetailsForm
                                discountDetails={selectedDiscountSettings}
                                submitButtonLabel='Update'
                                isEditing={productSettingDetailsModalIsEditing}
                                actionButtonClassName={Styles['submit-button']}
                            />
                        </div>
                    )
                )
            }
        </Modal>
    );
};

export default DiscountDetailsModal;
